import getStore from '../store/store';
import { AriaDatapoint } from '../datapoints/AriaDatapoint';
import { getQueryStringParameter, hasQueryStringParameter } from 'owa-querystring';
import { safeStringify, validatePropertyBag } from './validatePropertyBag';

const datapointQueryStringParam = 'dp';

export default function(datapoint: AriaDatapoint) {
    var eventName = datapoint.eventName;
    if (
        (eventName &&
            hasQueryStringParameter(datapointQueryStringParam) &&
            (!getQueryStringParameter(datapointQueryStringParam) ||
                eventName
                    .toLowerCase()
                    .indexOf(getQueryStringParameter(datapointQueryStringParam).toLowerCase()) >
                    -1)) ||
        getStore().traceDatapoints
    ) {
        var datapointString =
            'Datapoint: ' +
            eventName +
            '-' +
            safeStringify(datapoint.properties) +
            '-' +
            validatePropertyBag(datapoint);
        // This is a debugging tool that developers use to test if there datapoints are getting logged
        // tslint:disable-next-line:no-console
        console.log(datapointString);
    }
}
